/**
 * The field itself: yard lines, hash marks, and the yard numbers that run along
 * both sidelines. The far-side numbers are rotated, the way they are painted on
 * a real field so they read correctly from the opposite stand.
 */
const YARDS = [10, 20, 30, 40, 50, 40, 30, 20, 10];

function Numbers({ flip = false }: { flip?: boolean }) {
  return (
    <div className={`absolute inset-x-0 flex justify-between px-[5%] ${flip ? 'top-1.5' : 'bottom-1.5'}`}>
      {YARDS.map((y, i) => (
        <span key={i}
          className="font-cond text-[11px] font-bold leading-none tracking-[0.12em] text-white/25 md:text-[13px]"
          style={flip ? { transform: 'rotate(180deg)' } : undefined}>
          {y}
        </span>
      ))}
    </div>
  );
}

export function FieldLines({ numbers = true, opacity = 0.6 }: { numbers?: boolean; opacity?: number }) {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      <div className="absolute inset-0 bg-yard" style={{ opacity }} />
      {/* hash marks down the middle, dotted between the numbers */}
      <div className="absolute inset-x-0 top-1/2 flex -translate-y-1/2 justify-between px-[4%]">
        {Array.from({ length: 24 }, (_, i) => <span key={i} className="h-[6px] w-px bg-white/20" />)}
      </div>
      {numbers && <><Numbers flip /><Numbers /></>}
    </div>
  );
}
